import { IdApiInterface } from '@environments/assets/environment.interface';
import { environment } from '@environments/environment';
import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import idApiConfig from '@config/apis/id/id-api.config';

export const authnConfig: OpenIdConfiguration = {
  authority: idApiConfig.baseUrl ?? undefined,
  clientId: (environment.apis.id as IdApiInterface).shopStewardWebClientId,
  ignoreNonceAfterRefresh: true,
  logLevel: environment.oidc.debug ? LogLevel.Debug : LogLevel.None,
  maxIdTokenIatOffsetAllowedInSeconds: 300,
  postLoginRoute: '/login',
  postLogoutRedirectUri: environment.frontend.postLogoutRedirectUri,
  redirectUrl: environment.frontend.redirectUrl,
  renewTimeBeforeTokenExpiresInSeconds: 60,
  responseType: 'code',
  scope: 'openid',
  silentRenew: true,
  tokenRefreshInSeconds: 50,
  triggerAuthorizationResultEvent: true,
  triggerRefreshWhenIdTokenExpired: false,
  useRefreshToken: true,
  customParamsAuthRequest: {
    acr_values: 'http://schemas.openid.net/pape/policies/2007/06/multi-factor',
  },
};
